import { BsTelephone } from "react-icons/bs";
import { CiLocationOn } from "react-icons/ci";
import { MdDeliveryDining, MdOutlineCancel } from "react-icons/md";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { RiProgress2Fill } from "react-icons/ri";
import { SlCheck } from "react-icons/sl";
import { useSelector } from "react-redux";
import moment from "moment";
import { formattedAmount } from "../../../utils/helpers/Functions.helper";
import DropdownMenubar from "../../../components/Menubar/DropdownMenubar";
import { Badge } from "primereact/badge";
import OrderApi from "../../../apis/order.apis";
import { toast } from "react-toastify";
import PrintInvoice from "./PrintInvoice";
import { DeliveryManApis } from "../../../apis/delivery.apis";

function OrderDetails({
  deliveryAddress,
  handleCloseOrderModal,
  orderDetails,
  orderData,
  onOrderUpdated,
}) {
  const { theme } = useSelector((state) => state.theme);
  console.log("I am rendering OrderDetails component", orderDetails);
  console.log("orderData", orderData);

  const handleAction = async (data, action) => {
    if (!action?.vendor_action) return;

    const updatePayload = {
      orderId: data?._id,
      vendor_action: action.vendor_action,
    };

    try {
      console.log("data:", data);
      // 1) Update order (vendor accept/reject)
      const res = await OrderApi.updateOrders(updatePayload);
      toast.success(res?.data?.message || "Order updated");

      // 2) If ACCEPT → create delivery-man order
      //       if (action.vendor_action === "ACCEPT") {
      //         const customerName = [
      //           orderData?.created_by?.first_name,
      //           orderData?.created_by?.last_name,
      //         ]
      //           .filter(Boolean)
      //           .join(" ");

      //           const deliveryAddress = [
      //   orderData?.delivery_address?.flat_no,
      //   orderData?.delivery_address?.street,
      //   orderData?.delivery_address?.landmark,
      //   orderData?.delivery_address?.city?.name,
      //   orderData?.delivery_address?.country?.name,
      //   orderData?.delivery_address?.pin_code,
      // ]
      //   .filter(Boolean)
      //   .join(", ");

      //         const dmPayload = {
      //           // Customer Details
      //           customerName: customerName || data?.customerName || "",
      //           customerPhone:
      //             orderData?.created_by?.phone_number || data?.customerPhone || "",

      //           // Store Details
      //           store_name:
      //             orderData?.orderDetails[0]?.vendor?.first_name ||
      //             data?.store_name ||
      //             "",
      //           store_address:
      //             orderData?.orderDetails[0]?.vendor?.address ||
      //             data?.store_address ||
      //             "",
      //           store_coordinates: {
      //             latitude:
      //               orderData?.orderDetails?.[0]?.vendor?.location
      //                 ?.coordinates?.[1] ??
      //               data?.store_coordinates?.latitude ??
      //               data?.store?.location?.coordinates?.[1],

      //             longitude:
      //               orderData?.orderDetails?.[0]?.vendor?.location
      //                 ?.coordinates?.[0] ??
      //               data?.store_coordinates?.longitude ??
      //               data?.store?.location?.coordinates?.[0],
      //           },

      //           // Address Details
      //           customer_order_id: data?._id, // often use orderId as customer_order_id
      //           address: deliveryAddress||orderData?.delivery_address?.address || data?.address || "",
      //           landmark: orderData?.delivery_address?.landmark || data?.landmark || "",
      //           pincode: orderData?.delivery_address?.pin_code  || data?.pincode || "",
      //           coordinates: {
      //             latitude:
      //               orderData?.delivery_address?.city?.latitude ??
      //               data?.coordinates?.latitude ??
      //               data?.deliveryAddress?.location?.coordinates?.[1],
      //             longitude:
      //              orderData?.delivery_address?.city?.longitude ??
      //               data?.coordinates?.longitude ??
      //               data?.deliveryAddress?.location?.coordinates?.[0],
      //           },

      //           // Pricing Details
      //           item_price:orderData?.orderDetails[0]?.price?.$numberDecimal ??data?.item_price ??data?.totalItemPrice?.$numberDecimal ?? 0,
      //           delivery_price:
      //             orderData?.orderDetails[0]?.price?.$numberDecimal ??data?.item_price ??data?.totalItemPrice?.$numberDecimal ?? data?.pricing?.delivery_price ??
      //             data?.delivery_price ??
      //             data?.deliveryCharge ??
      //             0,

      //           // Payment Details
      //           payment_method:
      //             data?.payment?.method || data?.payment_method || "COD",
      //         };

      //         // (optional) quick validation before calling API
      //         if (!dmPayload.customerPhone || !dmPayload.address) {
      //           console.warn("Missing delivery payload fields:", dmPayload);
      //           // You can toast an error or still proceed depending on your requirement
      //         } else {
      //           const dmRes =
      //             await DeliveryManApis.createOrderForDeliveryMan(dmPayload);
      //           toast.success(dmRes?.data?.message || "Delivery order created");
      //         }
      //       }

      // 3) Refresh UI + close modal
      await onOrderUpdated();
      handleCloseOrderModal();
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <div
      className={`py-6 px-4 mx-auto rounded-lg shadow-md transition-all duration-300 ease-in-out ${
        theme === "light"
          ? "bg-white text-[#2D3748]"
          : "bg-darkThirsary text-darkSecondary"
      }`}
    >
      <div className="mb-6 border-b border-gray-300 pb-4">
        <div className="flex flex-col gap-2 justify-between">
          <div className=" p-3 border border-gray-100 bg-gray-100 rounded-lg shadow-sm">
            <p className="text-sm font-medium">
              Invoice #{orderData?.order_id} -{" "}
              {moment(deliveryAddress?.createdAt).format("DD MMM YYYY hh:mm A")}
            </p>
            <p>
              Payment status:{" "}
              <span
                className={`text-sm ${
                  orderData?.payment_status === "UNPAID"
                    ? "text-RedColor"
                    : "text-green500"
                }`}
              >
                {orderData?.payment_status}
              </span>
            </p>
            <p className="text-sm text-[#6B7280]">
              Payment type {orderData?.pay_type}
            </p>
          </div>
          <div
            className={`${
              orderData?.delivery_status === "CANCELLED"
                ? "bg-RedColor"
                : "bg-blue900"
            } text-white px-4 py-2 rounded-md text-sm text-center shadow`}
          >
            <p>{orderData?.delivery_status}</p>
            <p>
              {moment(deliveryAddress?.updatedAt).format("DD MMM YYYY hh:mm A")}
            </p>
          </div>
        </div>
      </div>

      <div className="mb-6">
        <h3 className="font-semibold mb-2 text-lg">Order by</h3>
        <p className="text-xl font-semibold hover:text-blue900 transition duration-300">
          {deliveryAddress?.name ?? "N/A"}
        </p>
        <div className="flex justify-between items-center mt-1">
          <p className="text-[#6B7280] text-xl hover:text-blue900 transition duration-300">
            {deliveryAddress?.phone_number ?? "N/A"}
          </p>
          <BsTelephone className="text-2xl text-blue900 hover:text-blue700 transition duration-300" />
        </div>

        <div className="flex items-center p-2 gap-4 mt-4 bg-gray-100 rounded-lg shadow-sm">
          <CiLocationOn className="text-3xl text-blue900" />
          <p className="text-gray-700">
            {deliveryAddress?.flat_no ?? "N/A"},{" "}
            {deliveryAddress?.landmark ?? "N/A"},
            {deliveryAddress?.street ?? "N/A"},{" "}
            {deliveryAddress?.pin_code ?? "N/A"}
          </p>
        </div>
      </div>

      {/* delivery man details */}
   { orderData?.orderDetails?.[0]?.assigned_delivery_personnel && <div className="mb-6">
        <h3 className="font-semibold mb-3 text-lg">Delivery Man Details</h3>

        {(() => {
          const dp = orderData?.orderDetails?.[0]?.assigned_delivery_personnel;

          const firstName = dp?.firstName?.trim();
          const lastName = dp?.lastName?.trim();
          const fullName =
            firstName || lastName
              ? `${firstName || ""} ${lastName || ""}`.trim()
              : "N/A";

          const phone = dp?.phoneNumber?.trim() || "N/A";
          const profilePicture = dp?.profilePicture || "";

          const initials =
            ((firstName?.[0] || "") + (lastName?.[0] || "")).toUpperCase() ||
            "DM";

          const canCall = phone !== "N/A";

          return (
            <div className="rounded-xl border border-gray-200 p-4 bg-white shadow-sm flex gap-4 items-start">
              {/* Image / Avatar */}
              <div className="w-20 h-20 rounded-xl overflow-hidden bg-gray-100 flex items-center justify-center shrink-0">
                {profilePicture ? (
                  <img
                    src={profilePicture}
                    alt={fullName}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      // hide broken image → show fallback initials instead
                      e.currentTarget.style.display = "none";
                    }}
                  />
                ) : (
                  <span className="text-gray-700 font-semibold text-xl">
                    {initials}
                  </span>
                )}

                {/* fallback initials if image fails to load */}
                {profilePicture && (
                  <span className="text-gray-700 font-semibold text-xl hidden">
                    {initials}
                  </span>
                )}
              </div>

              {/* Details */}
              <div className="flex-1 min-w-0">
                <p className="text-lg font-semibold text-gray-900 truncate">
                  {fullName}
                </p>

                <div className="flex justify-between items-center mt-1 gap-3">
                  <p className="text-[#6B7280] text-base truncate">{phone}</p>

                  {canCall ? (
                    <a
                      href={`tel:${phone}`}
                      className="p-2 rounded-full bg-blue-50 hover:bg-blue-100 transition"
                      aria-label="Call delivery man"
                    >
                      <BsTelephone className="text-xl text-blue900" />
                    </a>
                  ) : (
                    <div className="p-2 rounded-full bg-gray-100 cursor-not-allowed">
                      <BsTelephone className="text-xl text-gray-400" />
                    </div>
                  )}
                </div>

                {/* Optional: show vehicle info if you have it */}
                {(dp?.vehicleType ||
                  dp?.vehicleDetails?.registrationNumber) && (
                  <p className="text-sm text-gray-500 mt-2">
                    {dp?.vehicleType || ""}
                    {dp?.vehicleType && dp?.vehicleDetails?.registrationNumber
                      ? " • "
                      : ""}
                    {dp?.vehicleDetails?.registrationNumber || ""}
                  </p>
                )}
              </div>
            </div>
          );
        })()}
      </div>}

      <hr className="my-4 border-gray-300" />

      {orderDetails.map((details, index) => (
        <div className="mb-6 p-4 bg-gray-50 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200">
          <div className="flex justify-between items-center">
            <h3 className="font-bold text-xl text-[#2D3748]">
              {details?.product?.name ?? "Unnamed Product"}
            </h3>
            <div>
              <GetVendorInfo row={details} handleAction={handleAction} />
            </div>
          </div>

          <div className="flex justify-between items-center mb-4 mt-2">
            <p className="text-blue900 font-semibold">
              {details?.quantity ?? 0} Item
              {(details?.quantity ?? 0) > 1 ? "s" : ""}
            </p>
          </div>
          <div className="flex justify-between items-center">
            <p className="text-GreenColor text-lg font-semibold">
              {formattedAmount(Number(details?.price?.$numberDecimal ?? 0))}
            </p>
            <OrderStatus row={details} />
          </div>
          <hr className="mt-2 border-gray-300" />
          <PrintInvoice
            details={details}
            deliveryDetails={deliveryAddress}
            vendorDetails={details.vendor}
            index={index}
          />
          {/* <Accordion multiple activeIndex={[index]}>
            <AccordionTab header={<p className="text-lg font-bold my-4">Invoice</p>}>
              <TaxData
                key={`${index}t`}
                item={details?.product?.product_details}
              />
              <DeliveryFeeData key={`${index}d`} data={details?.delivery_fee} />
            </AccordionTab>
          </Accordion> */}
        </div>
      ))}
    </div>
  );
}

export default OrderDetails;

const OrderStatus = ({ row }) => {
  let severity;
  if (row.delivery_status === "DELIVERED") {
    severity = "success";
  } else if (row.delivery_status === "WAITING") {
    severity = "warning";
  } else if (row.delivery_status === "ACCEPTED") {
    severity = "success";
  } else if (row.delivery_status === "CANCELLED") {
    severity = "danger";
  } else if (row.delivery_status === "ASSIGNED_TO_DELIVERYMAN") {
    severity = "primary";
  } else if (row.delivery_status === "RETURN_REQUESTED") {
    severity = "warning";
  }

  return row.delivery_status ? (
    <Badge className="px-1" severity={severity} value={row.delivery_status} />
  ) : null;
};

const DD = ({ MenuItems }) => {
  return (
    <div className="w-[1.5rem] btn pl-2 h-[1.5rem] rounded-sm flex justify-center items-center">
      <DropdownMenubar
        menuItem={[
          {
            label: "Action",
            items: MenuItems,
          },
        ]}
      />
    </div>
  );
};

const GetVendorInfo = ({ row, handleAction }) => {
  const status = row?.delivery_status;
  const filterAssign = (items) =>
    items.filter(
      (i) => !(i.vendorKey === "ASSIGN" && row.vendor_action === "ASSIGN"),
    );

  switch (status) {
    case "WAITING":
      return (
        <DD
          MenuItems={[
            {
              label: "ACCEPT",
              icon: <SlCheck style={{ color: "rgb(15 61 100)" }} />,
              command: () =>
                handleAction && handleAction(row, { vendor_action: "ACCEPT" }),
            },
            {
              label: "REJECT",
              icon: <MdOutlineCancel style={{ color: "rgb(15 61 100)" }} />,
              command: () =>
                handleAction && handleAction(row, { vendor_action: "REJECT" }),
            },
          ]}
        />
      );

    case "RETURN_REQUESTED":
      return (
        <DD
          MenuItems={[
            {
              label: "ACCEPT RETURN",
              icon: <SlCheck style={{ color: "rgb(15 61 100)" }} />,
              command: () =>
                handleAction &&
                handleAction(row, { vendor_action: "ACCEPT_RETURN" }),
            },
            {
              label: "REJECT RETURN",
              icon: <MdOutlineCancel style={{ color: "rgb(15 61 100)" }} />,
              command: () =>
                handleAction &&
                handleAction(row, { vendor_action: "REJECT_RETURN" }),
            },
          ]}
        />
      );

    case "REJECTED":
      return <>Rejected</>;

    case "ACCEPTED":
      return (
        <DD
          MenuItems={filterAssign([
            {
              label: "ASSIGN",
              vendorKey: "ASSIGN",
              icon: <RiProgress2Fill style={{ color: "rgb(15 61 100)" }} />,
              command: () =>
                handleAction && handleAction(row, { vendor_action: "ASSIGN" }),
            },
            {
              label: "CANCEL",
              icon: <MdOutlineCancel style={{ color: "rgb(15 61 100)" }} />,
              command: () =>
                handleAction && handleAction(row, { vendor_action: "CANCEL" }),
            },
          ])}
        />
      );

    case "PREPARED":
      return (
        <DD
          MenuItems={filterAssign([
            {
              label: "READY",
              icon: (
                <IoCheckmarkDoneCircleOutline
                  style={{ color: "rgb(15 61 100)" }}
                />
              ),
              command: () =>
                handleAction && handleAction(row, { vendor_action: "READY" }),
            },
            {
              label: "CANCEL",
              icon: <MdOutlineCancel style={{ color: "rgb(15 61 100)" }} />,
              command: () =>
                handleAction && handleAction(row, { vendor_action: "CANCEL" }),
            },
          ])}
        />
      );

    case "READY":
      return (
        <DD
          MenuItems={filterAssign([
            {
              label: "ASSIGN",
              vendorKey: "ASSIGN",
              icon: <MdDeliveryDining style={{ color: "rgb(15 61 100)" }} />,
              command: () =>
                handleAction && handleAction(row, { vendor_action: "ASSIGN" }),
            },
            {
              label: "CANCEL",
              icon: <MdOutlineCancel style={{ color: "rgb(15 61 100)" }} />,
              command: () =>
                handleAction && handleAction(row, { vendor_action: "CANCEL" }),
            },
          ])}
        />
      );

    case "ASSIGNED":
      return (
        <DD
          MenuItems={filterAssign([
            {
              label: "ASSIGN",
              vendorKey: "ASSIGN",
              icon: <MdDeliveryDining style={{ color: "rgb(15 61 100)" }} />,
              command: () =>
                handleAction && handleAction(row, { vendor_action: "ASSIGN" }),
            },
            {
              label: "CANCEL",
              icon: <MdOutlineCancel style={{ color: "rgb(15 61 100)" }} />,
              command: () =>
                handleAction && handleAction(row, { vendor_action: "CANCEL" }),
            },
          ])}
        />
      );

    default:
      return <></>;
  }
};
